import type { ComponentProps } from "react";

import { forwardRef } from "react";

const IconFolder = forwardRef<SVGSVGElement, ComponentProps<"svg">>(
  (props, ref) => {
    return (
      <svg
        ref={ref}
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M15.8333 5.83325H9.71667C9.31097 5.83307 8.91927 5.68493 8.615 5.41659L6.72167 3.74992H13.75C14.3025 3.74992 14.8324 3.96941 15.2231 4.36011C15.6138 4.75081 15.8333 5.28072 15.8333 5.83325ZM15.8333 5.83325C16.2754 5.83325 16.6993 6.00885 17.0118 6.32141C17.3244 6.63397 17.5 7.05789 17.5 7.49992V14.9999C17.5 15.4419 17.3244 15.8659 17.0118 16.1784C16.6993 16.491 16.2754 16.6666 15.8333 16.6666H4.16667C3.72464 16.6666 3.30072 16.491 2.98816 16.1784C2.67559 15.8659 2.5 15.4419 2.5 14.9999V4.99992C2.5 4.55789 2.67559 4.13397 2.98816 3.82141C3.30072 3.50885 3.72464 3.33325 4.16667 3.33325H5.62083C6.02653 3.33343 6.41823 3.48158 6.7225 3.74992"
          stroke="currentColor"
          strokeWidth="1.25"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  },
);
IconFolder.displayName = "IconFolder";

export { IconFolder };
